export default __webpack_public_path__ + "static/qrcode-linkedin-834839a65b5d946a4f5abe67d0ed53f0.jpeg";